module.exports = __webpack_public_path__ + "static/media/startpage2025_480.e44f1e74.png";